"use client"

import Link from "next/link"
import { ArrowRight } from "lucide-react"
import { Button } from "@/components/ui/button"
import { RequestAccessButton } from "@/components/marketing/request-access-dialog"

export function LandingCta() {
  return (
    <section className="border-y border-border bg-surface py-20 md:py-24">
      <div className="mx-auto max-w-3xl px-6">
        <div className="rounded-2xl border border-border bg-card px-6 py-12 text-center shadow-sm md:px-10 md:py-14">
          <h2 className="text-balance text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Попробуйте живое досье дела
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-pretty text-lg text-muted-foreground">
            Без внедрения, с первого дня. Платный пилот с измеряемой окупаемостью и влиянием на дорожную карту.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button size="lg" asChild>
              <Link href="/login">
                Начать работу
                <ArrowRight className="size-4" />
              </Link>
            </Button>
            <RequestAccessButton size="lg" variant="outline" />
          </div>
        </div>
      </div>
    </section>
  )
}
